export default __webpack_public_path__ + "static/media/Software-Gestao-Assiduidade.f230cbba.webp";